import { SORT_DIRECTIONS } from "../tableConstants";

/**
 * Filters room types by search query (matches against displayName and code).
 */
export const filterRoomTypesBySearch = (roomTypes, query) => {
  if (!query || !query.trim()) return roomTypes;
  const lowerQuery = query.toLowerCase().trim();
  return roomTypes.filter(
    (room) =>
      room.displayName?.toLowerCase().includes(lowerQuery) ||
      room.code?.toLowerCase().includes(lowerQuery)
  );
};

/**
 * Sorts room types alphabetically by code.
 * "desc" = A-Z, "asc" = Z-A, null = no-op.
 * Returns a new array (no mutation).
 */
export const sortRoomTypesByRoom = (roomTypes, sortDirection) => {
  if (!sortDirection) return roomTypes;
  return [...roomTypes].sort((a, b) => {
    const codeA = (a.code || "").toLowerCase();
    const codeB = (b.code || "").toLowerCase();
    if (codeA < codeB) return sortDirection === SORT_DIRECTIONS.DESC ? -1 : 1;
    if (codeA > codeB) return sortDirection === SORT_DIRECTIONS.DESC ? 1 : -1;
    return 0;
  });
};

/**
 * Sorts room types by isActive status.
 * "desc" = Active first, "asc" = Inactive first, null = no-op.
 * Returns a new array (no mutation).
 */
export const sortRoomTypesByStatus = (roomTypes, sortDirection) => {
  if (!sortDirection) return roomTypes;
  return [...roomTypes].sort((a, b) => {
    const aActive = a.isActive ? 1 : 0;
    const bActive = b.isActive ? 1 : 0;
    return sortDirection === SORT_DIRECTIONS.DESC
      ? bActive - aActive
      : aActive - bActive;
  });
};

/**
 * Formats a min/max occupancy range for display.
 * Returns "min | max" with dash fallback for nulls.
 */
export const formatOccupancyRange = (min, max) => {
  const minStr = min != null ? String(min) : "-";
  const maxStr = max != null ? String(max) : "-";
  return `${minStr} | ${maxStr}`;
};
